export default __webpack_public_path__ + "static/media/quarter_face.de428651.png";